import { Head } from '@unhead/react';
import { useTranslations } from '@vocab/react';
import { Box, Heading, List, Stack, Text } from 'braid-design-system';

import translations from './.vocab';
import fixing from './images/fixing.svg';

export const GeneralErrorMessage = () => {
  const { t } = useTranslations(translations);

  return (
    <>
      <Head>
        <title> {t('CAN_WE_TRY_AGAIN')}</title>
      </Head>
      <Box
        display="flex"
        justifyContent="center"
        paddingY="xlarge"
        paddingX="small"
      >
        <Box maxWidth="xsmall">
          <Stack space="large">
            <Box dangerouslySetInnerHTML={{ __html: fixing }} />
            <Heading level="2" weight="regular">
              {t('CAN_WE_TRY_AGAIN')}
            </Heading>
            <Text>{t('BEAR_WITH_US_WE_ARE_HAVING_TECHNICAL_ISSUES')}</Text>

            <Stack space="small">
              <Text>{t('TRY')}</Text>
              <List space="small">
                <Text>{t('REFRESHING_THE_PAGE')}</Text>
                <Text>{t('CLEARING_YOUR_BROWSER_HISTORY')}</Text>
              </List>
            </Stack>
          </Stack>
        </Box>
      </Box>
    </>
  );
};
